import { LayerVisibility, MapButton } from '@ljagis/react-mapping';
import {
  Box,
  ClickAwayListener,
  Typography,
  makeStyles
} from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';
import CollapseIcon from '@material-ui/icons/OpenInNew';
import React, { useState } from 'react';

const useStyles = makeStyles((theme) => ({
  layerVisibilitySpacingFix: {
    // Checkboxes in LayerVisibility wider than desired
    // and creating unneeded spacing between checkbox and text.
    // Not configurable through component props, override with CSS.
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(4)
    }
  }
}));

const LayerToggle: React.VFC = () => {
  const classes = useStyles();

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const expand = () => setIsExpanded(true);
  const collapse = () => setIsExpanded(false);

  return isExpanded ? (
    <ClickAwayListener onClickAway={collapse}>
      <Box>
        <Box display="flex" flexDirection="row" alignItems="flex-start">
          <Box ml={2} mt={1.5} flex={1}>
            <Typography noWrap color="primary">
              Map Layers
            </Typography>
          </Box>
          <MapButton onClick={collapse}>
            <CollapseIcon color="action" fontSize="small" />
          </MapButton>
        </Box>
        <Box className={classes.layerVisibilitySpacingFix}>
          <LayerVisibility toggleAllButton={false} />
        </Box>
      </Box>
    </ClickAwayListener>
  ) : (
    <MapButton onClick={expand}>
      <LayersIcon color="action" style={{ fontSize: 20 }} />
    </MapButton>
  );
};

export default LayerToggle;
